const storesObj = {
  currency: {
    US: {
      country_code: "US",
      country_name: "United States",
      website_url: "https://us.purifair.com",
      country_currency: "$",
      short_name: "USA",
      flag_svg:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:v="https://vecta.io/nano"><circle cx="256" cy="256" r="256" fill="#f0f0f0"/><path d="M244.87 256H512a256.28 256.28 0 0 0-8.819-66.783H244.87V256zm0-133.565h229.556a257.35 257.35 0 0 0-59.07-66.783H244.87v66.783zM256 512c60.25 0 115.626-20.824 159.356-55.652H96.644C140.374 491.176 195.75 512 256 512zM37.574 389.565h436.852c12.58-20.53 22.338-42.97 28.755-66.783H8.82c6.417 23.814 16.174 46.254 28.755 66.783z" fill="#d80027"/><path d="M118.584 39.978h23.33l-21.7 15.765 8.29 25.51-21.7-15.765-21.7 15.765 7.16-22.037c-19.106 15.915-35.852 34.56-49.652 55.337h7.475l-13.813 10.035a255.58 255.58 0 0 0-6.194 10.938l6.596 20.3-12.306-8.94c-3.06 6.48-5.857 13.108-8.372 19.873l7.267 22.368h26.822l-21.7 15.765 8.29 25.51-21.7-15.765L1.98 224.08A258.47 258.47 0 0 0 0 256h256V0c-50.572 0-97.715 14.67-137.416 39.978zm9.918 190.422l-21.7-15.765-21.7 15.765 8.29-25.51-21.7-15.765h26.822l8.288-25.51 8.288 25.51h26.822l-21.7 15.765 8.29 25.51zm-8.29-100.083l8.29 25.51-21.7-15.765-21.7 15.765 8.29-25.51-21.7-15.765h26.822l8.288-25.51 8.288 25.51h26.822l-21.7 15.765zM220.328 230.4l-21.7-15.765-21.7 15.765 8.29-25.51-21.7-15.765h26.822l8.288-25.51 8.288 25.51h26.822l-21.7 15.765 8.29 25.51zm-8.29-100.083l8.29 25.51-21.7-15.765-21.7 15.765 8.29-25.51-21.7-15.765h26.822l8.288-25.51 8.288 25.51h26.822l-21.7 15.765zm0-74.574l8.29 25.51-21.7-15.765-21.7 15.765 8.29-25.51-21.7-15.765h26.822l8.288-25.51 8.288 25.51h26.822l-21.7 15.765z" fill="#0052b4"/></svg>',
    },
    CA: {
      country_code: "CA",
      country_name: "Canada",
      website_url: "https://ca.purifair.com",
      country_currency: "C$",
      short_name: "CAN",
      flag_svg:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:v="https://vecta.io/nano"><circle cx="256" cy="256" r="256" fill="#f0f0f0"/><path d="M512 256c0-101.494-59.065-189.2-144.696-230.598v461.195C452.935 445.2 512 357.494 512 256zM0 256c0 101.494 59.065 189.2 144.696 230.598V25.402C59.065 66.8 0 154.506 0 256zm300.522 33.4l44.52-22.26-22.26-11.13v-22.26L278.26 256l22.26-44.522h-22.26L256 178.087l-22.26 33.4h-22.26L233.74 256l-44.522-22.26V256l-22.26 11.13 44.52 22.26-11.13 22.26h44.522v33.4h22.26v-33.4h44.522z" fill="#d80027"/></svg>',
    },
    NZ: {
      country_code: "NZ",
      country_name: "New Zealand",
      website_url: "https://nz.purifair.com",
      country_currency: "NZ$",
      short_name: "NZ",
      flag_svg:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:v="https://vecta.io/nano"><path d="M512 256c0 141.384-114.616 256-256 256S0 397.384 0 256C0 256.06 256 .028 256 0c141.384 0 256 114.616 256 256z" fill="#0052b4"/><g fill="#f0f0f0"><path d="M256 0h-.043.043zm-.685 256H256v-.685l-.685.685z"/><path d="M256 133.565L255.957 0C114.592.024 0 114.63 0 256h133.565v-75.21L208.777 256h46.54l.685-.685v-46.537l-75.213-75.213H256z"/></g><path d="M129.515 33.4a257.39 257.39 0 0 0-96.125 96.125V256h66.783V100.174H256V33.4H129.515zM256 224.52l-90.953-90.953-31.48.002L256 256v-31.48zm187.33-34.56l5.525 17.006h17.88l-14.466 10.5 5.526 17.005-14.466-10.5-14.467 10.5 5.526-17.005-14.467-10.5h17.88zM379.4 312.393l8.3 25.5h26.82l-21.7 15.764 8.3 25.5-21.7-15.765-21.7 15.765 8.3-25.5-21.7-15.764h26.82zm2.415-200.347l6.908 21.26h22.35L393 146.44l6.908 21.258-18.083-13.14-18.082 13.14 6.907-21.258-18.082-13.135h22.35zm-61.503 77.17l8.288 25.5h26.822l-21.7 15.764 8.3 25.5-21.7-15.765-21.7 15.765 8.3-25.5-21.7-15.764h26.82z" fill="#d80027"/></svg>',
    },
    AU: {
      country_code: "AU",
      country_name: "Australia",
      website_url: "https://au.purifair.com",
      country_currency: "A$",
      short_name: "AUS",
      flag_svg:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:v="https://vecta.io/nano"><path d="M512 256c0 141.384-114.616 256-256 256S0 397.384 0 256C0 256.06 256 .03 256 0c141.384 0 256 114.616 256 256z" fill="#0052b4"/><g fill="#f0f0f0"><path d="M256 0l-.043.001L256 0zm-.685 256H256v-.685l-.685.685z"/><path d="M256 133.566L255.957.001C114.592.024 0 114.63 0 256h133.565v-75.212L208.777 256h46.54l.685-.685V208.78l-75.213-75.213H256z"/></g><path d="M129.515 33.4a257.39 257.39 0 0 0-96.125 96.125V256h66.783V100.174H256V33.4H129.515zM256 224.52l-90.953-90.952h-31.48L256 256v-31.48z" fill="#d80027"/><path d="M154.395 300.522l14.05 29.378 31.727-7.333-14.208 29.302 25.514 20.233-31.767 7.16.1 32.564-25.405-20.373-25.404 20.373.1-32.564-31.768-7.16 25.515-20.233-14.2-29.302 31.73 7.333zm228.89 55.652l7.025 14.7 15.864-3.667-7.105 14.65 12.758 10.117-15.884 3.58.044 16.282-12.702-10.187-12.702 10.187.044-16.282-15.883-3.58 12.757-10.117-7.104-14.65 15.863 3.667zm-65.35-155.826l7.024 14.7 15.864-3.668-7.104 14.65 12.757 10.117-15.883 3.58.043 16.282-12.7-10.187L305.23 256l.043-16.282-15.883-3.58 12.757-10.117-7.104-14.65 15.864 3.668zm65.35-89.044l7.025 14.7 15.864-3.667-7.104 14.65 12.756 10.116-15.883 3.58.044 16.282-12.702-10.187-12.702 10.187.044-16.282-15.883-3.58 12.756-10.116-7.103-14.65 15.863 3.667zm57.084 66.783l7.024 14.7 15.864-3.668-7.104 14.65 12.757 10.117-15.884 3.58.044 16.28-12.7-10.186-12.702 10.186.043-16.28-15.883-3.58 12.757-10.117-7.104-14.65 15.863 3.668zM399.55 256l5.525 17.006h17.882l-14.467 10.5 5.527 17.005-14.467-10.5-14.466 10.5 5.525-17.005-14.466-10.5h17.88z" fill="#f0f0f0"/></svg>',
    },
    EN: {
      country_code: "EN",
      country_name: "England",
      website_url: "https://eu.purifair.com",
      country_currency: "€",
      short_name: "EN",
      flag_svg:
        '<?xml version="1.0" encoding="UTF-8"?> <svg version="1.0" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <circle cx="300" cy="300" r="300" fill="#039"/><g id="a" transform="translate(300,60)" fill="#fc0"><g id="b"><path id="c" transform="rotate(18 0,-40)" d="m0-40v40h20"/> <use transform="scale(-1,1)" xlink:href="#c"/> </g> <use transform="rotate(72)" xlink:href="#b"/> <use transform="rotate(144)" xlink:href="#b"/> <use transform="rotate(216)" xlink:href="#b"/> <use transform="rotate(288)" xlink:href="#b"/> </g> <use transform="rotate(30 300,300) rotate(330 300,60)" xlink:href="#a"/><use transform="rotate(60 300,300) rotate(300 300,60)" xlink:href="#a"/><use transform="rotate(90 300,300) rotate(270 300,60)" xlink:href="#a"/><use transform="rotate(120 300,300) rotate(240 300,60)" xlink:href="#a"/> <use transform="rotate(150 300,300) rotate(210 300,60)" xlink:href="#a"/> <use transform="rotate(180 300,300) rotate(180 300,60)" xlink:href="#a"/> <use transform="rotate(210 300,300) rotate(150 300,60)" xlink:href="#a"/> <use transform="rotate(240 300,300) rotate(120 300,60)" xlink:href="#a"/>  <use transform="rotate(270 300,300) rotate(90 300,60)" xlink:href="#a"/><use transform="rotate(300 300,300) rotate(60 300,60)" xlink:href="#a"/><use transform="rotate(330 300,300) rotate(30 300,60)" xlink:href="#a"/> </svg>',
    },
  },
  languages: {
    DE: {
      country_code: "DE",
      country_name: "Germany",
      website_url: "https://eu.purifair.com/de",
      country_currency: "€",
      short_name: "DE",
      flag_svg:
        '<?xml version="1.0" encoding="UTF-8"?> <svg version="1.0" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <circle cx="300" cy="300" r="300" fill="#039"/><g id="a" transform="translate(300,60)" fill="#fc0"><g id="b"><path id="c" transform="rotate(18 0,-40)" d="m0-40v40h20"/> <use transform="scale(-1,1)" xlink:href="#c"/> </g> <use transform="rotate(72)" xlink:href="#b"/> <use transform="rotate(144)" xlink:href="#b"/> <use transform="rotate(216)" xlink:href="#b"/> <use transform="rotate(288)" xlink:href="#b"/> </g> <use transform="rotate(30 300,300) rotate(330 300,60)" xlink:href="#a"/><use transform="rotate(60 300,300) rotate(300 300,60)" xlink:href="#a"/><use transform="rotate(90 300,300) rotate(270 300,60)" xlink:href="#a"/><use transform="rotate(120 300,300) rotate(240 300,60)" xlink:href="#a"/> <use transform="rotate(150 300,300) rotate(210 300,60)" xlink:href="#a"/> <use transform="rotate(180 300,300) rotate(180 300,60)" xlink:href="#a"/> <use transform="rotate(210 300,300) rotate(150 300,60)" xlink:href="#a"/> <use transform="rotate(240 300,300) rotate(120 300,60)" xlink:href="#a"/>  <use transform="rotate(270 300,300) rotate(90 300,60)" xlink:href="#a"/><use transform="rotate(300 300,300) rotate(60 300,60)" xlink:href="#a"/><use transform="rotate(330 300,300) rotate(30 300,60)" xlink:href="#a"/> </svg>',
    },
    AT: {
      country_code: "DE",
      country_name: "Germany",
      website_url: "https://eu.purifair.com/de",
      country_currency: "€",
      short_name: "DE",
      flag_svg:
        '<?xml version="1.0" encoding="UTF-8"?> <svg version="1.0" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <circle cx="300" cy="300" r="300" fill="#039"/><g id="a" transform="translate(300,60)" fill="#fc0"><g id="b"><path id="c" transform="rotate(18 0,-40)" d="m0-40v40h20"/> <use transform="scale(-1,1)" xlink:href="#c"/> </g> <use transform="rotate(72)" xlink:href="#b"/> <use transform="rotate(144)" xlink:href="#b"/> <use transform="rotate(216)" xlink:href="#b"/> <use transform="rotate(288)" xlink:href="#b"/> </g> <use transform="rotate(30 300,300) rotate(330 300,60)" xlink:href="#a"/><use transform="rotate(60 300,300) rotate(300 300,60)" xlink:href="#a"/><use transform="rotate(90 300,300) rotate(270 300,60)" xlink:href="#a"/><use transform="rotate(120 300,300) rotate(240 300,60)" xlink:href="#a"/> <use transform="rotate(150 300,300) rotate(210 300,60)" xlink:href="#a"/> <use transform="rotate(180 300,300) rotate(180 300,60)" xlink:href="#a"/> <use transform="rotate(210 300,300) rotate(150 300,60)" xlink:href="#a"/> <use transform="rotate(240 300,300) rotate(120 300,60)" xlink:href="#a"/>  <use transform="rotate(270 300,300) rotate(90 300,60)" xlink:href="#a"/><use transform="rotate(300 300,300) rotate(60 300,60)" xlink:href="#a"/><use transform="rotate(330 300,300) rotate(30 300,60)" xlink:href="#a"/> </svg>',
    },
    ES: {
      country_code: "ES",
      country_name: "Spain",
      website_url: "https://eu.purifair.com/es",
      country_currency: "€",
      short_name: "ES",
      flag_svg:
        '<?xml version="1.0" encoding="UTF-8"?> <svg version="1.0" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <circle cx="300" cy="300" r="300" fill="#039"/><g id="a" transform="translate(300,60)" fill="#fc0"><g id="b"><path id="c" transform="rotate(18 0,-40)" d="m0-40v40h20"/> <use transform="scale(-1,1)" xlink:href="#c"/> </g> <use transform="rotate(72)" xlink:href="#b"/> <use transform="rotate(144)" xlink:href="#b"/> <use transform="rotate(216)" xlink:href="#b"/> <use transform="rotate(288)" xlink:href="#b"/> </g> <use transform="rotate(30 300,300) rotate(330 300,60)" xlink:href="#a"/><use transform="rotate(60 300,300) rotate(300 300,60)" xlink:href="#a"/><use transform="rotate(90 300,300) rotate(270 300,60)" xlink:href="#a"/><use transform="rotate(120 300,300) rotate(240 300,60)" xlink:href="#a"/> <use transform="rotate(150 300,300) rotate(210 300,60)" xlink:href="#a"/> <use transform="rotate(180 300,300) rotate(180 300,60)" xlink:href="#a"/> <use transform="rotate(210 300,300) rotate(150 300,60)" xlink:href="#a"/> <use transform="rotate(240 300,300) rotate(120 300,60)" xlink:href="#a"/>  <use transform="rotate(270 300,300) rotate(90 300,60)" xlink:href="#a"/><use transform="rotate(300 300,300) rotate(60 300,60)" xlink:href="#a"/><use transform="rotate(330 300,300) rotate(30 300,60)" xlink:href="#a"/> </svg>',
    },
    FR: {
      country_code: "FR",
      country_name: "France",
      website_url: "https://eu.purifair.com/fr",
      country_currency: "€",
      short_name: "FR",
      flag_svg:
        '<?xml version="1.0" encoding="UTF-8"?> <svg version="1.0" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <circle cx="300" cy="300" r="300" fill="#039"/><g id="a" transform="translate(300,60)" fill="#fc0"><g id="b"><path id="c" transform="rotate(18 0,-40)" d="m0-40v40h20"/> <use transform="scale(-1,1)" xlink:href="#c"/> </g> <use transform="rotate(72)" xlink:href="#b"/> <use transform="rotate(144)" xlink:href="#b"/> <use transform="rotate(216)" xlink:href="#b"/> <use transform="rotate(288)" xlink:href="#b"/> </g> <use transform="rotate(30 300,300) rotate(330 300,60)" xlink:href="#a"/><use transform="rotate(60 300,300) rotate(300 300,60)" xlink:href="#a"/><use transform="rotate(90 300,300) rotate(270 300,60)" xlink:href="#a"/><use transform="rotate(120 300,300) rotate(240 300,60)" xlink:href="#a"/> <use transform="rotate(150 300,300) rotate(210 300,60)" xlink:href="#a"/> <use transform="rotate(180 300,300) rotate(180 300,60)" xlink:href="#a"/> <use transform="rotate(210 300,300) rotate(150 300,60)" xlink:href="#a"/> <use transform="rotate(240 300,300) rotate(120 300,60)" xlink:href="#a"/>  <use transform="rotate(270 300,300) rotate(90 300,60)" xlink:href="#a"/><use transform="rotate(300 300,300) rotate(60 300,60)" xlink:href="#a"/><use transform="rotate(330 300,300) rotate(30 300,60)" xlink:href="#a"/> </svg>',
    },
    IT: {
      country_code: "IT",
      country_name: "Italy",
      website_url: "https://eu.purifair.com/it",
      country_currency: "€",
      short_name: "IT",
      flag_svg:
        '<?xml version="1.0" encoding="UTF-8"?> <svg version="1.0" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <circle cx="300" cy="300" r="300" fill="#039"/><g id="a" transform="translate(300,60)" fill="#fc0"><g id="b"><path id="c" transform="rotate(18 0,-40)" d="m0-40v40h20"/> <use transform="scale(-1,1)" xlink:href="#c"/> </g> <use transform="rotate(72)" xlink:href="#b"/> <use transform="rotate(144)" xlink:href="#b"/> <use transform="rotate(216)" xlink:href="#b"/> <use transform="rotate(288)" xlink:href="#b"/> </g> <use transform="rotate(30 300,300) rotate(330 300,60)" xlink:href="#a"/><use transform="rotate(60 300,300) rotate(300 300,60)" xlink:href="#a"/><use transform="rotate(90 300,300) rotate(270 300,60)" xlink:href="#a"/><use transform="rotate(120 300,300) rotate(240 300,60)" xlink:href="#a"/> <use transform="rotate(150 300,300) rotate(210 300,60)" xlink:href="#a"/> <use transform="rotate(180 300,300) rotate(180 300,60)" xlink:href="#a"/> <use transform="rotate(210 300,300) rotate(150 300,60)" xlink:href="#a"/> <use transform="rotate(240 300,300) rotate(120 300,60)" xlink:href="#a"/>  <use transform="rotate(270 300,300) rotate(90 300,60)" xlink:href="#a"/><use transform="rotate(300 300,300) rotate(60 300,60)" xlink:href="#a"/><use transform="rotate(330 300,300) rotate(30 300,60)" xlink:href="#a"/> </svg>',
    },
  },
};
var ljsLang = localStorage.getItem("ljs-lang");

const allStoresObject = {  ...storesObj.currency , ...storesObj.languages };

// const urlParams = new URLSearchParams(window.location.search);
// const langParam = urlParams.get("lang");

// if (["en", "es", "de", "it", "fr", "nz", "au", "us", "ca"].includes(langParam)) {
//   localStorage.setItem("incache", langParam.toUpperCase());
//   localStorage.setItem("ljs-lang", langParam.toUpperCase());
// }

const incache_set = localStorage.getItem("incache");

// if (
//   incache_set &&
//   !window.location.href.includes("checkouts") &&
//   !window.location.href.includes(allStoresObject[incache_set].website_url) &&
//   !window.location.href.includes("pages")
// ) {
//   window.location.replace(allStoresObject[incache_set].website_url);
//   console.log(
//     incache_set,
//     window.location.href,
//     allStoresObject[incache_set].website_url
//   );
// }

window.addEventListener("DOMContentLoaded", function () {
  // const modalWrapper = document.querySelector(".redirect-modal__selector");
  const chooseStoreWrapper = document.querySelectorAll(".choose-store");
  const statusStoreWrapper = document.querySelectorAll(".locations-header");
  const incache_set = localStorage.getItem("incache");
  // const cancelBtn = document.querySelector(".cancel_btn");
  const access_key = "e86428501b8529742069f8e25ce8ca7a";

  if (localStorage.getItem("ljs-lang")) {
    localStorage.setItem(
      "ljs-lang",
      allStoresObject[Shopify.locale.toUpperCase()]?.country_code
    );
  }

  async function ipstackCall() {
    const response = await fetch(
      `https://api.ipstack.com/check?access_key=${access_key}`
    );
    const ipstack_json = await response.json();
    return ipstack_json;
  }

  if (incache_set === "yes") {
    localStorage.removeItem("incache");
  }

  ipstackCall().then((object) => {
    const { country_code: locationCN, country_name: locationCGM } = object;

    document.addEventListener("click", function (e) {
      console.log(e.target.className);
      // if (
      //   e.target &&
      //   e.composedPath().filter((item) => item.className === "cancel_btn")
      //     .length > 0
      // ) {
      //   localStorage.setItem(
      //     "incache",
      //     allStoresObject[Shopify.locale.toUpperCase()]?.country_code
      //   );
      //   localStorage.setItem(
      //     "ljs-lang",
      //     allStoresObject[Shopify.locale.toUpperCase()]?.country_code
      //   );
      //   document
      //     .querySelector(".redirect-modal__selector")
      //     .classList.add("hide-modal");
      // }
      // if (
      //   e.target &&
      //   e
      //     .composedPath()
      //     .filter((item) => item.className === "redirected_button").length > 0
      // ) {
      //   localStorage.setItem("incache", locationCN);
      //   localStorage.setItem("ljs-lang", locationCN);
      //   document
      //     .querySelector(".redirect-modal__selector")
      //     .classList.add("hide-modal");
      // }
      if (
        e.target &&
        e.composedPath().filter((item) => item.className === "store-status-li")
          .length > 0
      ) {
        const dataLoc = e
          .composedPath()
          .filter((item) => item.className === "store-status-li")[0]
          ?.dataset.cn;
        localStorage.setItem("incache", dataLoc);
        localStorage.setItem("ljs-lang", dataLoc);
        document
          .querySelector(".redirect-modal__selector")
          .classList.add("hide-modal");
      }
      // if (e.target && e.target.className === "redirect-modal__wrapper") {
      //   document
      //     .querySelector(".redirect-modal__selector")
      //     .classList.add("hide-modal");
      // }
    });

    function fun() {
      let countries = "";
      for (const country in allStoresObject) {
        if (
          country ===
            allStoresObject["AU"]?.country_code ||
          country === "AT"
        )
          continue;
        const listItem = `<li><a class="store-status-li" data-cn="${allStoresObject[country].country_code}" href="${allStoresObject[country].website_url}"><div class="country-name-span">${allStoresObject[country].flag_svg} ${allStoresObject[country].short_name}</div> <div class="country-currency-span">${allStoresObject[country].country_currency}</div></a></li>`;
        countries = countries + listItem;
      }
      return countries;
    }

    statusStoreWrapper.forEach((item) =>
      item.insertAdjacentHTML("afterbegin", `${fun()}`)
    );

    let chooseStoreHtml;

    chooseStoreHtml = `<div class="country-name-span">${
      allStoresObject["AU"]?.flag_svg
    }</em> ${
      allStoresObject["AU"]?.short_name
    } </div> <div class="country-currency-span"> ${
      allStoresObject["AU"]?.country_currency
    } <svg xmlns="http://www.w3.org/2000/svg" width="9.768" height="5.509" viewBox="0 0 9.768 5.509"><defs><style>.a{fill:none;stroke:#2b2b2b;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.25px;}</style></defs><g transform="translate(0.884 0.884)"><g transform="translate(0 0)"><path class="a" d="M8,0,4,4,0,0"/></g></g></svg></div>`;

    chooseStoreWrapper.forEach((item) =>
      item.insertAdjacentHTML("afterbegin", chooseStoreHtml)
    );

    const triggerShow = (trigger) => {
      trigger.addEventListener("click", () => {
        trigger.classList.toggle("trigger-show");
      });
    };

    if (screen.width < 990) {
      document
        .querySelectorAll(".trigger")
        .forEach((trigger) => triggerShow(trigger));
    }

    // if (
    //   allStoresObject[locationCN]?.country_code === Shopify.locale.toUpperCase()
    // )
    //   return;

    // if (incache_set) return;

    // let html;

    // if (Object.keys(allStoresObject).includes(locationCN)) {
    //   html = `
    //   <div class="redirect-modal__wrapper">
    //     <div class="redirect-modal__content">
    //       <h6>Choose The Shop</h6>
    //       <p>Hey, we noticed that you are in ${locationCGM}, but
    //         you're about to visit ${
    //           allStoresObject[Shopify.locale.toUpperCase()]?.country_name
    //         } Store</p>
    //         <p class="redirect-modal__p">Choose Shop Here:</p>
    //         <div class="redirect-modal__buttons">
    //         <div class="cancel_btn">
    //           <div class="country-name-span">${
    //             allStoresObject[Shopify.locale.toUpperCase()]?.flag_svg
    //           }</em> ${
    //     allStoresObject[Shopify.locale.toUpperCase()]?.short_name
    //   } </div> <div class="country-currency-span"> ${
    //     allStoresObject[Shopify.locale.toUpperCase()]?.country_currency
    //   }</div>
    //         </div>
    //         <a href="${
    //           allStoresObject[locationCN]?.website_url
    //         }" class="redirected_button"><div class="country-name-span">${
    //     allStoresObject[locationCN]?.flag_svg
    //   }</em> ${
    //     allStoresObject[locationCN]?.short_name
    //   } </div> <div class="country-currency-span"> ${
    //     allStoresObject[locationCN]?.country_currency
    //   } </div></a>
    //         <div class="module-redirect">
    //         <div class="trigger">
    //           <span><em><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><defs><style>.a{fill:#2b2b2b;}</style></defs><path class="a" d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,18.333a8.3,8.3,0,0,1-5.833-2.392V14.583a1.568,1.568,0,0,1,.383-.947A1.93,1.93,0,0,0,5,12.5c0-.795-.717-.875-1.1-.918a1.16,1.16,0,0,1-.686-.21,2.636,2.636,0,0,1-.346-.536A3.212,3.212,0,0,0,1.693,9.482,8.337,8.337,0,0,1,10,1.667c.229,0,.454.016.678.034a.844.844,0,0,0-.139.088.416.416,0,0,0,.017.606,1.113,1.113,0,0,1,.184.2c-.009.02-.086.151-.512.367A3.017,3.017,0,0,0,8.591,4.809a1.015,1.015,0,0,0,.282.9.416.416,0,0,0,.295.122,3.251,3.251,0,0,0,1.458-.421A3.164,3.164,0,0,1,12.083,5C13.719,5,15,5.366,15,5.833c0,.171-.053.224-.074.243-.2.2-.9.188-1.514.179-.162,0-.328-.006-.5-.006a1.8,1.8,0,0,1-.944-.179,2.275,2.275,0,0,0-1.139-.238,4.03,4.03,0,0,0-2.795.955,2.326,2.326,0,0,0-.561,2.03c.011.124.022.241.022.348,0,.821.839,1.25,1.667,1.25a5.32,5.32,0,0,1,2.5.417,2.413,2.413,0,0,0,.25,1.04,1.454,1.454,0,0,1,.166.626.416.416,0,0,1-.114.337,1.311,1.311,0,0,0-.3.913,3.593,3.593,0,0,0,.94,1.946.417.417,0,0,0,.31.138.407.407,0,0,0,.1-.013c.245-.063,2.4-.655,2.4-2.07a.794.794,0,0,1,.347-.745,1.137,1.137,0,0,0,.486-.922,4.682,4.682,0,0,1,1.142-1.8.417.417,0,0,0-.053-.609,5.305,5.305,0,0,1-1.518-1.862,2.383,2.383,0,0,1,.551.4.694.694,0,0,0,.536.2,2.169,2.169,0,0,0,1.118-.618A8.306,8.306,0,0,1,10,18.333Z"/></svg></em> Other <svg xmlns="http://www.w3.org/2000/svg" width="9.768" height="5.509" viewBox="0 0 9.768 5.509"><defs><style>.a{fill:none;stroke:#2b2b2b;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.25px;}</style></defs><g transform="translate(0.884 0.884)"><g transform="translate(0 0)"><path class="a" d="M8,0,4,4,0,0"/></g></g></svg></span>
    //           <ul class="locations">
    //           ${fun()}
    //           </ul>
    //         </div>
    //       </div>
    //         </div>

    //     </div>
    //   </div>
    //   `;
    // }

    // if (!Object.keys(allStoresObject).includes(locationCN)) {
    //   chooseStoreHtml = `<em>🌐</em> INT | $`;
    //   html = `
    //   <div class="redirect-modal__wrapper">
    //     <div class="redirect-modal__content">
    //     <h6>Choose The Shop</h6>
    //     <p>Hey, we noticed that you are in ${locationCGM}, but
    //       you're about to visit ${
    //         allStoresObject[Shopify.locale.toUpperCase()]?.country_name
    //       } Store</p>
    //       <p class="redirect-modal__p">Choose Shop Here:</p>
    //         <div class="redirect-modal__buttons redirect-modal__buttons_2">
    //         <div class="cancel_btn">              <div class="country-name-span">${
    //           allStoresObject[Shopify.locale.toUpperCase()]?.flag_svg
    //         }</em> ${
    //     allStoresObject[Shopify.locale.toUpperCase()]?.short_name
    //   } </div> <div class="country-currency-span"> ${
    //     allStoresObject[Shopify.locale.toUpperCase()]?.country_currency
    //   }</div></div>

    //         <div class="module-redirect">
    //         <div class="trigger">
    //           <span><em><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><defs><style>.a{fill:#2b2b2b;}</style></defs><path class="a" d="M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,18.333a8.3,8.3,0,0,1-5.833-2.392V14.583a1.568,1.568,0,0,1,.383-.947A1.93,1.93,0,0,0,5,12.5c0-.795-.717-.875-1.1-.918a1.16,1.16,0,0,1-.686-.21,2.636,2.636,0,0,1-.346-.536A3.212,3.212,0,0,0,1.693,9.482,8.337,8.337,0,0,1,10,1.667c.229,0,.454.016.678.034a.844.844,0,0,0-.139.088.416.416,0,0,0,.017.606,1.113,1.113,0,0,1,.184.2c-.009.02-.086.151-.512.367A3.017,3.017,0,0,0,8.591,4.809a1.015,1.015,0,0,0,.282.9.416.416,0,0,0,.295.122,3.251,3.251,0,0,0,1.458-.421A3.164,3.164,0,0,1,12.083,5C13.719,5,15,5.366,15,5.833c0,.171-.053.224-.074.243-.2.2-.9.188-1.514.179-.162,0-.328-.006-.5-.006a1.8,1.8,0,0,1-.944-.179,2.275,2.275,0,0,0-1.139-.238,4.03,4.03,0,0,0-2.795.955,2.326,2.326,0,0,0-.561,2.03c.011.124.022.241.022.348,0,.821.839,1.25,1.667,1.25a5.32,5.32,0,0,1,2.5.417,2.413,2.413,0,0,0,.25,1.04,1.454,1.454,0,0,1,.166.626.416.416,0,0,1-.114.337,1.311,1.311,0,0,0-.3.913,3.593,3.593,0,0,0,.94,1.946.417.417,0,0,0,.31.138.407.407,0,0,0,.1-.013c.245-.063,2.4-.655,2.4-2.07a.794.794,0,0,1,.347-.745,1.137,1.137,0,0,0,.486-.922,4.682,4.682,0,0,1,1.142-1.8.417.417,0,0,0-.053-.609,5.305,5.305,0,0,1-1.518-1.862,2.383,2.383,0,0,1,.551.4.694.694,0,0,0,.536.2,2.169,2.169,0,0,0,1.118-.618A8.306,8.306,0,0,1,10,18.333Z"/></svg></em> Other <svg xmlns="http://www.w3.org/2000/svg" width="9.768" height="5.509" viewBox="0 0 9.768 5.509"><defs><style>.a{fill:none;stroke:#2b2b2b;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.25px;}</style></defs><g transform="translate(0.884 0.884)"><g transform="translate(0 0)"><path class="a" d="M8,0,4,4,0,0"/></g></g></svg></span>
    //           <ul class="locations">
    //           ${fun()}
    //           </ul>
    //         </div>
    //       </div>
    //         </div>
    //     </div>
    //   </div>
    //   `;
    // }

    // modalWrapper.insertAdjacentHTML("afterbegin", html);

    // if (screen.width < 990) {
    //   modalWrapper
    //     .querySelectorAll(".trigger")
    //     .forEach((trigger) => triggerShow(trigger));
    // }
  });
});
